import React, { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { AddToListButton } from "@activecollab/components";
import PropTypes from "prop-types";
import { hasCollaborativePermissionsOnProject } from "~/store/selectors/selector.users.jsx";
import DependenciesBodyTemplate from "./DependenciesBodyTemplate.jsx";

const DependenciesBodyWithoutItems = ({ onClick, projectId }) => {
  const { t } = useTranslation();

  const visible = useSelector((state) => hasCollaborativePermissionsOnProject(state, projectId));

  const handleClick = useCallback(
    (event) => {
      event.preventDefault();
      onClick();
    },
    [onClick]
  );

  return visible ? (
    <DependenciesBodyTemplate>
      <div className="parent_add_mode_trigger tw-mb-4">
        <AddToListButton
          text={t("Add a Dependency")}
          onClick={handleClick}
          className="tw--ml-1"
        />
      </div>
    </DependenciesBodyTemplate>
  ) : null;
};

DependenciesBodyWithoutItems.propTypes = {
  onClick: PropTypes.func,
  projectId: PropTypes.number,
};

DependenciesBodyWithoutItems.displayName = `DependenciesBodyWithoutItems`;

export default DependenciesBodyWithoutItems;
